import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from 'react-router-dom';
import TableContainer from '../../../../Components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";
import menuSvg from '../../../../assets/images/svg/menu.svg'
import { numberWithCommas } from "../../../../helpers/globalHelper"

import DeleteModal from '../../../../Components/Common/DeleteModal';

import { Col, Row, UncontrolledTooltip, Modal, ModalHeader, ModalBody, Form, Input, FormFeedback, Label, Card, CardBody, Button } from "reactstrap";

//flatpickr
import "flatpickr/dist/themes/material_green.css";
import Spinners from "Components/Common/Spinner";
import { useMenuCreateMutation, useMenuDeleteMutation, useMenuFindAllQuery, useMenuUpdateMutation } from '../../../../store';

const Detail = () => {
  const [customQuery, setCustomQuery] = useState<any>();
  const [isLoading, setLoading] = useState(true)

  const [modal, setModal] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const [menuOne, setMenuOne] = useState<any>(null)
  const [menuList, setMenuList] = useState<any>();
  const [menuCount, setMenuCount] = useState<any>();

  const { data, error, isFetching } = useMenuFindAllQuery(customQuery);

  const [menuCreate, menuCreateResult] = useMenuCreateMutation();
  const [menuUpdate, menuUpdateResult] = useMenuUpdateMutation();
  const [menuDelete, menuDeleteResult] = useMenuDeleteMutation();

  // Datatable дээр pagination харуулахад хэрэгтэй
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();

  useEffect(() => {
    setMenuList(data?.data)
    setLoading(false)
    setMenuCount(menuList?.length)

    setCustomPagination(data?.pagination)
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1}&pageSize=${customPageSize !== undefined ? customPageSize : 25}`;
    setCustomQuery(tempQuery)
  }, [data, menuCount, customPageSize, customPageLength, customPagination])


  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setMenuOne(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleJobClick = useCallback((arg: any) => {
    const tempMenu = arg;

    setMenuOne({
      id: tempMenu.menu_id,
      menu_url: tempMenu.menu_url,
      name: tempMenu.name,
      sort_order: tempMenu.sort_order,
      parent_id: tempMenu.parent_id,
      menu_icon: tempMenu.menu_icon,
      // code: tempMenu.code,
    });
    setIsEdit(true);
    toggle();
  }, []);

  //delete Job
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (selectRowData) => {
    setMenuOne(selectRowData);
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (menuOne) {
      menuDelete(menuOne.menu_id)
      setDeleteModal(false);
    }
  };
  const handleJobClicks = () => {
    setIsEdit(false);
    setMenuOne(null);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        header: '№',
        accessorKey: "menu_id",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => {
          return <Link to="#" className="text-body fw-bold">{cellProps.row.original.menu_id}</Link>
        }
      },
      {
        header: "Код",
        accessorKey: "code",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Нэр",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'url',
        accessorKey: "menu_url",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Icon',
        accessorKey: "menu_icon",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Parent code',
        accessorKey: "parent_code",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Sort',
        accessorKey: "sort_order",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Үйлдэл',
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-info"
                  onClick={(event: any) => {
                    const menuData = cellProps.row.original;
                    event.preventDefault();
                    handleJobClick(menuData);
                  }}
                >
                  <i className="mdi mdi-pencil-outline" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Засах
                  </UncontrolledTooltip>
                </Link>
              </li>

              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={(event: any) => {
                    const selectRowData = cellProps.row.original;
                    event.preventDefault();
                    onClickDelete(selectRowData);
                  }}
                >
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Soft delete
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>

          );
        }
      },
    ],
    [handleJobClick]
  );


  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      id: menuOne?.id,
      menu_url: menuOne?.menu_url,
      name: menuOne?.name,
      sort_order: menuOne?.sort_order,
      parent_id: menuOne?.parent_id,
      menu_icon: menuOne?.menu_icon,
      // code: menuOne?.code,
    },
    validationSchema: Yup.object({
      menu_url: Yup.string().required("Утга оруулна уу !"),
      name: Yup.string().required("Утга оруулна уу !"),
      sort_order: Yup.number().required("Утга оруулна уу !"),
      // parent_id: Yup.string().required("Утга оруулна уу !"),
      // menu_icon: Yup.string().required("Утга оруулна уу !"),
      // code: Yup.number().required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (isEdit) {
        const updateMenuList = {
          id: menuOne ? values.id : 0,
          menu_url: values.menu_url,
          name: values.name,
          sort_order: values.sort_order,
          parent_id: values.parent_id,
          menu_icon: values.menu_icon,
          // code: values.code,
        };

        menuUpdate(updateMenuList)
      } else {

        const newMenuList = {
          menu_url: values["menu_url"],
          name: values["name"],
          sort_order: values["sort_order"],
          parent_id: values["parent_id"],
          menu_icon: values["menu_icon"],
          // code: values["code"],
        };
        menuCreate(newMenuList)
      }
      validation.resetForm();
      toggle();
    },
  });

  return (
    <React.Fragment>
      <DeleteModal
        deleteName={menuOne?.name}
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody className="border-bottom">
              <div className="d-flex align-items-center">
                <img src={menuSvg} alt="" height="50" />
                <div className="flex-grow-1 ms-3">
                  <h5 className="fw-semibold">Мэдээлэл</h5>
                  <ul className="list-unstyled hstack gap-2 mb-0">
                    <li>
                      <i className="mdi mdi-table-row-height"></i> <span className="text-muted fw-semibold">Нийт: {numberWithCommas(menuCount)}</span>
                    </li>
                  </ul>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    handleJobClicks();
                  }}
                  className="btn btn-success  btn-label"
                >
                  <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр нэмэх
                </button>
              </div>
            </CardBody>
            <CardBody>
              {
                isLoading ? <Spinners setLoading={setLoading} />
                  :
                  <TableContainer
                    setCustomPageSize={setCustomPageSize}
                    setCustomPageLength={setCustomPageLength}
                    customPagination={customPagination}
                    columns={columns}
                    data={menuList || ""}
                    isCustomPageSize={true}
                    // isGlobalFilter={true}
                    isPagination={true}
                    colWidth={2}
                    SearchPlaceholder="Хэрэглэгч хайх . . ."
                    tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                    pagination="pagination"
                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                  />
              }
            </CardBody>
          </Card>

        </Col>
      </Row>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle} tag="h4">
          {!!isEdit ? "Меню засах" : "Меню нэмэх"}
        </ModalHeader>
        <ModalBody>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Row>
              <Col xs={12}>
                <div className="mb-3">
                  <Label> Меню нэр </Label>
                  <Input
                    name="name"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name && validation.errors.name ? true : false
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                  ) : null}
                </div>

                {/* <div className="mb-3">
                  <Label>Код </Label>
                  <Input
                    name="code"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.code || ""}
                    invalid={
                      validation.touched.code && validation.errors.code ? true : false
                    }
                  />
                  {validation.touched.code && validation.errors.code ? (
                    <FormFeedback type="invalid">{validation.errors.code}</FormFeedback>
                  ) : null}
                </div> */}

                <div className="mb-3">
                  <Label> Меню url</Label>
                  <Input
                    name="menu_url"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.menu_url || ""}
                    invalid={
                      validation.touched.menu_url && validation.errors.menu_url ? true : false
                    }
                  />
                  {validation.touched.menu_url && validation.errors.menu_url ? (
                    <FormFeedback type="invalid">{validation.errors.menu_url}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Меню icon</Label>
                  <Input
                    name="menu_icon"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.menu_icon || ""}
                    invalid={
                      validation.touched.menu_icon && validation.errors.menu_icon ? true : false
                    }
                  />
                  {validation.touched.menu_icon && validation.errors.menu_icon ? (
                    <FormFeedback type="invalid">{validation.errors.menu_icon}</FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Sort</Label>
                  <Input
                    name="sort_order"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.sort_order || ""}
                    invalid={
                      validation.touched.sort_order && validation.errors.sort_order ? true : false
                    }
                  />
                  {validation.touched.sort_order && validation.errors.sort_order ? (
                    <FormFeedback type="invalid">{validation.errors.sort_order}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Parent id </Label>
                  <Input
                    name="parent_id"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.parent_id || ""}
                    invalid={
                      validation.touched.parent_id && validation.errors.parent_id ? true : false
                    }
                  />
                  {validation.touched.parent_id && validation.errors.parent_id ? (
                    <FormFeedback type="invalid">{validation.errors.parent_id}</FormFeedback>
                  ) : null}
                </div>


              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-end">
                  <Button type="submit" color="success" className="save-user" > Save</Button>
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}


export default Detail;